import Avatar, { AvatarProps } from './Avatar';
import NextJsAvatar from './NextJsAvatar';

export type TeamAvatarProps = Omit<AvatarProps, 'srcs' | 'alt'> & {
  logo: {
    webp?: string;
    url?: string;
  } | null;
  name: string;
  nextjs?: boolean;
};

export default function TeamAvatar({ logo, name, onError, nextjs, ...props }: TeamAvatarProps) {
  if (nextjs) {
    return <NextJsAvatar srcs={[logo?.webp, logo?.url]} alt={name} onError={onError} coloredBackground {...props} />;
  } else {
    return <Avatar srcs={[logo?.webp, logo?.url]} alt={name} onError={onError} coloredBackground {...props} />;
  }
}
